<cfp-login-card [title]="'login.change' | translate">
  <cfp-change-password-form (successAfterAlertClose)="formSubmitSuccess()" (isSaving)="(isSaving)" />

  <div class="row">
    <div class="col-12">
      <cfp-button-loading
        [loading]="isSaving()"
        [buttonType]="'submit'"
        [classes]="'pull-right'"
        [buttonForm]="'changePasswordForm'"
        [dataTest]="'changePasswordButton'"
      >
        {{ 'login.submit' | translate }}
      </cfp-button-loading>
      <cfp-link [routerLink]="loginRoute" [classes]="'pull-left'" [disabled]="isSaving()">
        {{ 'login.cancel' | translate }}</cfp-link
      >
    </div>
  </div>
</cfp-login-card>
